var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "trans-qr"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', [_c('div', {
    staticClass: "qr-img"
  }, [_c('p', {
    staticClass: "img"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.qrsrc
    }
  })]), _vm._v(" "), (_vm.showAcc) ? _c('p', [_vm._v(_vm._s(_vm.txAccount.short_name) + ": "), _c('a', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.txAccount.bank_account),
      expression: "txAccount.bank_account",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopied),
      expression: "onCopied",
      arg: "success"
    }],
    staticClass: "ac-copy"
  }, [_vm._v(_vm._s(_vm.txAccount.bank_account))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "qr-action"
  }, [_c('p', [_vm._v(_vm._s(_vm.tips))])])])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.0.2@vue-loader/lib/template-compiler?{"id":"data-v-349438ed","hasScoped":true}!./~/_vue-loader@13.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/payment/TransQr.vue
// module id = 232
// module chunks = 0